import { render, staticRenderFns } from "./ConfigurarNotificacionForm.vue?vue&type=template&id=20430f66&"
import script from "./ConfigurarNotificacionForm.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarNotificacionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports